import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/sonner';
import { DashboardLayout } from './components/DashboardLayout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import PropertiesPage from './pages/PropertiesPage';
import StoresPage from './pages/StoresPage';
import ItemsPage from './pages/ItemsPage';
import CategoriesPage from './pages/CategoriesPage';
import UnitsPage from './pages/UnitsPage';
import VendorsPage from './pages/VendorsPage';
import StockInwardPage from './pages/StockInwardPage';
import StockIssuePage from './pages/StockIssuePage';
import StockTransferPage from './pages/StockTransferPage';
import CurrentStockPage from './pages/CurrentStockPage';
import StockAdjustmentsPage from './pages/StockAdjustmentsPage';
import UsersPage from './pages/UsersPage';
import RolesPage from './pages/RolesPage';
import ReportsPage from './pages/ReportsPage';
import QuickEntryPage from './pages/QuickEntryPage';
import QuickInwardPage from './pages/QuickInwardPage';
import QuickTransferPage from './pages/QuickTransferPage';
import SettingsPage from './pages/SettingsPage';
import HelpPage from './pages/HelpPage';
import PurchaseOrdersPage from './pages/PurchaseOrdersPage';
import GRNPage from './pages/GRNPage';
import GRNCreatePage from './pages/GRNCreatePage';
import ClientsPage from './pages/ClientsPage';
import PettyCashPage from './pages/PettyCashPage';
import IndentsPage from './pages/IndentsPage';
import AuditLogPage from './pages/AuditLogPage';
import ServiceReceivedPage from './pages/ServiceReceivedPage';
import ServiceTemplatesPage from './pages/ServiceTemplatesPage';
import ServiceItemsPage from './pages/ServiceItemsPage';
import StockAcknowledgmentPage from './pages/StockAcknowledgmentPage';
import ConsumptionPage from './pages/ConsumptionPage';
import PaymentsPage from './pages/PaymentsPage';
import BankAnalyticsPage from './pages/BankAnalyticsPage';
import MenuPOAssistantPage from './pages/MenuPOAssistantPage';
import PettyCashTeamPage from './pages/PettyCashTeamPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          
          {/* Standalone Mobile Routes */}
          <Route path="/petty-cash-team" element={<PettyCashTeamPage />} />
          
          {/* Protected Routes */}
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="quick-entry" element={<QuickEntryPage />} />
            <Route path="quick-inward" element={<QuickInwardPage />} />
            <Route path="quick-transfer" element={<QuickTransferPage />} />
            <Route path="properties" element={<PropertiesPage />} />
            <Route path="stores" element={<StoresPage />} />
            <Route path="items" element={<ItemsPage />} />
            <Route path="categories" element={<CategoriesPage />} />
            <Route path="units" element={<UnitsPage />} />
            <Route path="vendors" element={<VendorsPage />} />
            <Route path="stock-inward" element={<StockInwardPage />} />
            <Route path="stock-issue" element={<StockIssuePage />} />
            <Route path="stock-transfer" element={<StockTransferPage />} />
            <Route path="stock" element={<CurrentStockPage />} />
            <Route path="stock-adjustments" element={<StockAdjustmentsPage />} />
            <Route path="stock-acknowledgment" element={<StockAcknowledgmentPage />} />
            <Route path="consumption" element={<ConsumptionPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="roles" element={<RolesPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="purchase-orders" element={<PurchaseOrdersPage />} />
            <Route path="grn" element={<GRNPage />} />
            <Route path="grn/create/:poId" element={<GRNCreatePage />} />
            <Route path="srn" element={<ServiceReceivedPage />} />
            <Route path="service-templates" element={<ServiceTemplatesPage />} />
            <Route path="service-items" element={<ServiceItemsPage />} />
            <Route path="clients" element={<ClientsPage />} />
            <Route path="petty-cash" element={<PettyCashPage />} />
            <Route path="indents" element={<IndentsPage />} />
            <Route path="audit-logs" element={<AuditLogPage />} />
            <Route path="payments" element={<PaymentsPage />} />
            <Route path="bank-analytics" element={<BankAnalyticsPage />} />
            <Route path="menu-po" element={<MenuPOAssistantPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="help" element={<HelpPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      {/* Version indicator for deployment verification - remove after confirmed working */}
      <div style={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        background: '#22c55e',
        color: 'white',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '10px',
        zIndex: 9999,
        fontFamily: 'monospace'
      }}>
        v2026.03.14.v3
      </div>
    </AuthProvider>
  );
}

export default App;
